import React from 'react'
import { Tooltip } from 'antd'
import PropTypes from 'prop-types'
import './RecordStatusBadge.scss'

export const recordStatuses = {
  "Verified": {
    className: "verified",
    label: "V"
  },
  "Unverified": {
    className: "unverified",
    label: "U"
  },
  "Archived": {
    className: "archived",
    label: "A"
  },
}

const RecordStatusBadge = ({
  value,
  size = "medium",
  hasColor,
  style,
}) => {
  let classNames = ["record-status-badge", size]
  if (recordStatuses?.[value]?.className) {
    classNames.push(recordStatuses[value].className)
  }
  if (hasColor) {
    classNames.push('has-color')
  }

  if (!value) return null;

  return <Tooltip title={value}>
    <div
      style={style}
      className={classNames.join(" ")}>
      {recordStatuses?.[value]?.label}
    </div>
  </Tooltip>
}

RecordStatusBadge.propTypes = {
  value: PropTypes.oneOf(["", "Verified", "Unverified", "Archived"]),
  size: PropTypes.oneOf(["small", "medium"]),
  hasColor: PropTypes.bool,
  style: PropTypes.object,
}

export default RecordStatusBadge